import React from "react";
import "./HeadAndSub.css";

const HeadAndDesc = (props) => {
  // console.log(props['Martingale Status'],'ldjfldjkfj')
  // const classList = props.SubTitle === "Free Trial" ? ["SubTitle", "FreeTrialStatus"] : ["SubTitle"] && props.SubTitle === "Challenge" ? ["SubTitle", "ChallengeSTatus"] :  ["SubTitle"]  && props.SubTitle === "Varification" ? ["SubTitle", "VarificationSTatus"] : [`SubTitle ${props.SubTitleClass}`]
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          position: "relative",
          // flexDirection: "",
          padding: "20px 10px",
          textAlign: "center",
          gap: "10px",
        }}
        className={props.HeadAndSubClassName}
      >
        <p style={{marginBottom:"0"}} className={`HeadDesc ${props.HeadTitleClass}`}>{props.HeadTitle}</p>
        <p style={{marginBottom:"0"}} className={`SubDesc ${props.SubTitleClass}`}>{props.SubTitle}</p>
      </div>
    </>
  );
};
export default HeadAndDesc;
